import axios from "axios";

export const assignLocker = (
    propertyId: number,
    unitId: string,
): () => Promise<{ message: string, error: boolean, locker: number | null }> => {
    return async () => {
        return await axios
            .post(`/bms-assignments/${propertyId}/${unitId}`)
            .then(async (response) => {
                if (response?.data?.statusCode === 200 || response?.data?.statusCode === 201) {
                    return { message: response?.data?.message as string, error: false, locker: response?.data?.lockerNumber }
                } else {
                    return { message: response?.data?.message as string, error: true, locker: null };
                }
            })
            .catch((err) => {
                return { message: err?.response?.data?.message as string, error: true, locker: null };
            });
    };
};


export const removeAssignLocker = (propertyId: number, unitId: string, onSuccess: () => void, onFailure: (message: string) => void) => {
    return async () => {
        return await axios
            .delete(`/bms-assign-remove/${propertyId}/${unitId}`)
            .then(async (response) => {
                if (response?.data?.statusCode === 200) {
                    onSuccess()
                } else {
                    onFailure(response?.data?.message);
                }
            })
            .catch((error) => {
                onFailure(error?.response?.data?.message);
            })
    }
}